/**
 * useProductsPageData – Daten-Schicht für /v2/products (S6 Redesign-Shell)
 * Komponiert: useMergedProductsData + useProductsKpiData + useProductSync + useProductTableConfig
 * Plan 012 + S1/S2 Redesign-Mehrwert erhalten. useMergedProductsActions wird direkt
 * im ProductsV2 aufgerufen (braucht selectedIds aus useProductsPageUi).
 */
import type { IssueFilter } from '@/lib/api/channel-readiness'
import { useMergedProductsData } from './useMergedProductsData'
import { useProductsKpiData } from './useProductsKpiData'
import { useProductSync } from './useProductSync'
import { useProductTableConfig } from './useProductTableConfig'

export function useProductsPageData(
  channelId: string | null,
  page: number,
  search: string,
  issueFilter: IssueFilter | null,
  imageStatusFilter: string[],
) {
  const config = useProductTableConfig()
  const sync = useProductSync()
  const { products, total, totalPages, isLoading, isFetching } = useMergedProductsData(
    channelId, page, search, config.sorting, issueFilter, imageStatusFilter, config.filters,
  )
  const { kpi, seriesByProduct } = useProductsKpiData(products)

  return { config, sync, products, total, totalPages, isLoading, isFetching, kpi, seriesByProduct }
}
